import { render, staticRenderFns } from "./IssueOrder.vue?vue&type=template&id=3140234c&scoped=true&"
import script from "./IssueOrder.vue?vue&type=script&lang=js&"
export * from "./IssueOrder.vue?vue&type=script&lang=js&"
import style0 from "./IssueOrder.vue?vue&type=style&index=0&id=3140234c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140234c",
  null
  
)

export default component.exports